import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
    fetchComponentTypes,
    createComponentType,
    updateComponentType,
    deleteComponentType,
} from "../../api/maintenance/componentTypeService";

export const useComponentType = () => {
  const queryClient = useQueryClient();

  // Consulta optimizada para obtener tipos de mantenimiento
  const {
    data: componentTypes = [],
    error,
    isLoading,
  } = useQuery({
    queryKey: ["componentTypes"],
    queryFn: fetchComponentTypes,
    staleTime: 1000 * 60 * 5, // 5 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  // Reutilizable para invalidar caché
  const invalidateCache = () => {
    queryClient.invalidateQueries({ queryKey: ["componentTypes"] });
  };

  const createMutation = useMutation({
    mutationFn: createComponentType,
    onSuccess: invalidateCache,
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateComponentType(id, data),
    onSuccess: invalidateCache,
  });

  const deleteMutation = useMutation({
    mutationFn: deleteComponentType,
    onSuccess: invalidateCache,
  });

  return {
    componentTypes,
    isLoading,
    error,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
